import CalculationsAverage from '../utils/сalculationsAverage';
import {useEffect, useState} from 'react';
import CalculationsSum from '../utils/сalculationsSum';

export const useCalculations = (state) => {
  const [total, setTotal] = useState('');
  const [result, setResult] = useState({});
  const groupData = {};
  const calculationTypes = {};

  useEffect(() => {
    if (
      state?.currentValues === undefined
      || Object.keys(state?.currentValues).length === 0
    ) {
      return null;
    }

    const valuesArray = Object.values(state?.currentValues);
    const answersArray = valuesArray.map(obj => obj.answer);
    setTotal(() => CalculationsAverage(answersArray));


    for (const id in state?.currentValues) {
      state?.data?.questions?.find((el, index) => {
        let currentGroup = [];

        if (!!groupData[el.group]) {
          currentGroup.push(...groupData[el.group], state?.currentValues[id].answer);
        }

        if (`${index}` === id) {
          groupData[el.group] = currentGroup.length > 0
            ? currentGroup
            : [state?.currentValues[id].answer];
        }
      });
    }

  }, [state?.currentValues]);

  useEffect(() => {
    if (
      state?.data?.result === undefined
      || state?.data?.result.length === 0
    ) {
      return null;
    }

    state?.data?.result.map((item) => {
      const {values} = item;

      values && values.find((el) => {
        calculationTypes[el.group] = el['calculation_type'];
      });
    });

    if (Object.keys(calculationTypes).length === 0) return null;

    for (const key in groupData) {
      if (calculationTypes[key] === 'sum_up') {
        setResult(prevState => ({...prevState, [key]: CalculationsSum(groupData[key])}));
      }

      if (calculationTypes[key] === 'use_the_average') {
        setResult(prevState => ({...prevState, [key]: CalculationsAverage(groupData[key])}));
      }
    }

  }, [state?.data?.result, calculationTypes]);

  return {
    result,
    total,
    calculationTypes  // TODO: For debug info
  };
};
